var _g, _rect, _rect2, _g2, _rect3, _g3, _rect4, _path, _rect5, _path2, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicCustomizationFeature02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 181,
    viewBox: "0 0 275 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2033_20815)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 12,
    width: 203,
    height: 147,
    rx: 4,
    fill: "url(#paint0_linear_2033_20815)",
    fillOpacity: 0.4
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88.4375,
    y: 83.0312,
    width: 98.6541,
    height: 14.3208,
    rx: 7.16038,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 125.566,
    y: 50.6758,
    width: 24.3983,
    height: 24.3983,
    rx: 12.1992,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2033_20815)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    width: 47.2109,
    height: 141.633,
    rx: 6.36458,
    fill: "white",
    fillOpacity: 0.8
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8281,
    y: 5.10266,
    width: 39.5551,
    height: 41.4691,
    rx: 5.84477,
    fill: "#E1E8F6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2033_20815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.601 15.5222V17.6486M42.601 34.6601V36.7866M34.0952 26.1544H31.9688M36.5556 20.109L35.052 18.6054M48.6463 20.109L50.1499 18.6054M36.5556 32.2041L35.052 33.7077M48.6463 32.2041L50.1499 33.7077M53.2332 26.1544H51.1067M47.9171 26.1544C47.9171 29.0904 45.537 31.4705 42.601 31.4705C39.665 31.4705 37.2849 29.0904 37.2849 26.1544C37.2849 23.2184 39.665 20.8383 42.601 20.8383C45.537 20.8383 47.9171 23.2184 47.9171 26.1544Z",
    stroke: "#0A0F33",
    strokeWidth: 2.55173,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8281,
    y: 50.4019,
    width: 39.5551,
    height: 40.8311,
    rx: 5.84477,
    fill: "#E1E8F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6049 66.9012V71.7731L46.2856 71.7731M52.1747 70.8161C52.1747 76.1014 47.8902 80.3859 42.6049 80.3859C37.3197 80.3859 33.0352 76.1014 33.0352 70.8161C33.0352 65.5309 37.3197 61.2463 42.6049 61.2463C47.8902 61.2463 52.1747 65.5309 52.1747 70.8161Z",
    stroke: "#0A0F33",
    strokeWidth: 2.55194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8281,
    y: 95.0621,
    width: 39.5551,
    height: 41.4691,
    rx: 5.84477,
    fill: "#E1E8F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6368 125.125H37.0285C36.4005 125.125 36.0865 125.125 35.9411 125C35.815 124.893 35.748 124.731 35.761 124.566C35.776 124.375 35.9981 124.153 36.4421 123.709L45.2566 114.894C45.6672 114.484 45.8724 114.279 46.1091 114.202C46.3173 114.134 46.5416 114.134 46.7498 114.202C46.9865 114.279 47.1918 114.484 47.6023 114.894L51.6127 118.905V120.149M46.6368 125.125C48.3785 125.125 49.2494 125.125 49.9146 124.786C50.4998 124.488 50.9755 124.012 51.2737 123.427C51.6127 122.761 51.6127 121.89 51.6127 120.149M46.6368 125.125H37.929C36.1873 125.125 35.3164 125.125 34.6512 124.786C34.066 124.488 33.5902 124.012 33.2921 123.427C32.9531 122.761 32.9531 121.89 32.9531 120.149V111.441C32.9531 109.699 32.9531 108.828 33.2921 108.163C33.5902 107.578 34.066 107.102 34.6512 106.804C35.3164 106.465 36.1873 106.465 37.929 106.465H46.6368C48.3785 106.465 49.2494 106.465 49.9146 106.804C50.4998 107.102 50.9755 107.578 51.2737 108.163C51.6127 108.828 51.6127 109.699 51.6127 111.441V120.149M40.7279 112.167C40.7279 113.312 39.7997 114.24 38.6546 114.24C37.5096 114.24 36.5814 113.312 36.5814 112.167C36.5814 111.022 37.5096 110.093 38.6546 110.093C39.7997 110.093 40.7279 111.022 40.7279 112.167Z",
    stroke: "#0A0F33",
    strokeWidth: 2.55173,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2033_20815)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.0039,
    y: 157.325,
    width: 252.992,
    height: 10.0773,
    rx: 4.24306,
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2033_20815",
    x: 33.8785,
    y: 9.87847,
    width: 207.243,
    height: 151.243,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.06076
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2033_20815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2033_20815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2033_20815",
    x: 16.8785,
    y: -2.12153,
    width: 51.454,
    height: 145.876,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.06076
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2033_20815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2033_20815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2033_20815",
    x: 0.396267,
    y: 148.838,
    width: 274.207,
    height: 31.2925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.12153
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.30382
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2033_20815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2033_20815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2033_20815",
    x1: 137.5,
    y1: 12,
    x2: 137.5,
    y2: 159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2033_20815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.5173,
    height: 25.5173,
    fill: "white",
    transform: "translate(29.8438 13.3957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicCustomizationFeature02);
export default __webpack_public_path__ + "static/media/sonic-customization-feature-02.534ed3539b137c9dc221b2e3fd284f34.svg";
export { ForwardRef as ReactComponent };